import type { ParsedUrlQuery } from "querystring";
import { getDefaultPageRoute } from "./get-default-page-route";

interface GetNextUrlOptions {
  locale?: string;
  agentId?: string;
  isExternal: boolean;
  query: ParsedUrlQuery;
}

export function getNextUrl({
  query,
  locale,
  agentId,
  isExternal,
}: GetNextUrlOptions) {
  let { next } = query;

  if (!next) {
    console.log("pagiona returning default route", locale);
    return getDefaultPageRoute({ locale, isExternal, agentId });
  }

  if (Array.isArray(next)) {
    next = next.toString();
  }

  if (!next.startsWith("/")) {
    next = `/${next}`;
  }

  return next.replace(/\/+/g, "/");
}
